import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';

import {
    ROOMS_OPERATING_REPORT_GET_START,
    ROOMS_OPERATING_REPORT_GET_SUCCESS,
    ROOMS_OPERATING_REPORT_GET_ERROR,
    RoomsOperatingReportAction
} from './RoomsOperatingReportActionsTypes';

import type { RoomsOperatingReportDto } from './RoomsOperatingReportDto';
import { convertToRoomsOperatingReport } from './roomsOperatingReportConverter';

export type RoomsOperatingReportParams = {
    start?: string;
    end?: string;

    compare_today?: string;

    compare_mtd_start?: string;
    compare_mtd_end?: string;

    compare_ytd_start?: string;
    compare_ytd_end?: string;
};

export const getRoomsOperatingReport = (
    params: RoomsOperatingReportParams = {}
): ThunkAction<void, null, null, RoomsOperatingReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const state = store.getState();
        const { marketplaceId, token, timeZone } = state.login.auth;

        let url = `/rooms_operating_report?marketplace_id=${marketplaceId}`;

        const append = (key: string, value?: string) => {
            if (!value) return;
            url += `&${key}=${encodeURIComponent(value)}`;
        };

        append('start_date', params.start);
        append('end_date', params.end);

        append('compare_today', params.compare_today);

        append('compare_mtd_start', params.compare_mtd_start);
        append('compare_mtd_end', params.compare_mtd_end);

        append('compare_ytd_start', params.compare_ytd_start);
        append('compare_ytd_end', params.compare_ytd_end);

        try {
            const response: AxiosResponse<RoomsOperatingReportDto> = await ApiClient.get(
                url,
                createTokenConfig(token!)
            );

            dispatch(getSuccess(convertToRoomsOperatingReport(response.data, timeZone!)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Could not load Rooms Operating report.'));
            }
        }
    };
};

const getStart = (): RoomsOperatingReportAction => ({
    type: ROOMS_OPERATING_REPORT_GET_START
});

const getSuccess = (report: any): RoomsOperatingReportAction => ({
    type: ROOMS_OPERATING_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): RoomsOperatingReportAction => ({
    type: ROOMS_OPERATING_REPORT_GET_ERROR
});
